var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('Breadcrumb',{attrs:{"pgTitle":_vm.$t('nav.financialDues'),"pgIcon":'bx bx-money',"refs":_vm.refs,"addNew":_vm.addNew}}),_c('CardsAmount',{attrs:{"refs":_vm.refs,"slug":_vm.slug}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }